export default {
    'Email': 'Email',
    'Email Placeholder': 'Введи свой email',
    'Back to login': 'Вернутся к авторизации',
    'Restore Password Text': 'Для восстановления пароля укажи свой электронный адрес',
    'Restore Password Button': 'Скинуть пароль',
    'Timezone': 'Часовой пояс',
    'Avatar': 'Аватар',
    'SystemDefaultLanguage': 'Язык системы по умолчанию',
    'Name': 'Имя',
    'Surname': 'Фамилия',
    'Save Changes': 'Сохранить изменения',
    'restoreStatusTextFirst': 'Запрос на сброс пароля выслан.',
    'restoreStatusTextSecond': 'В скором времени вы получите электронное письмо.',
    'restoreStatusTextErrorFirst': 'Мы не смогли найти этот электронный адрес.',
    'restoreStatusTextErrorSecond': 'Проверьте введенные данные и повторите попытку.',
    'New Password Title': 'Восстановление пароля',
    'New Password': 'Новый пароль',
    'New Password Placeholder': 'Введи свой пароль',
    'Confirm new password': 'Повторите пароль',
}
